import { Box } from "@mui/material";

const styles = {
  dialogAnnotation: {
    backgroundColor: "#f1f3f3",
    borderRadius: 6,
    color: "green.main",
    width: "max-content",
    px: 3,
    py: 1,
    mb: 2,
  },
  tag: {
    color: "purple.dark",
  },
};

const UtilizeMergeTags = () => {
  return (
    <Box sx={styles.dialogAnnotation}>
      💭 Utilize personalization tags{" "}
      <Box component="span" sx={styles.tag}>
        &#123;First Name&#125;
      </Box>{" "}
      and{" "}
      <Box component="span" sx={styles.tag}>
        &#123;Brand Name&#125;
      </Box>
    </Box>
  );
};

export default UtilizeMergeTags;
